import styled from 'styled-components'

export const Error = styled.p`
  font-size: .75rem;
  color: var(--danger);
  margin: .5rem 0 0 0;
  padding: 0;
`
